import type { SocialAPI } from ".";
import HTTPStatus from "@/realize-shared/HTTPStatus";
import UIListener from "@/pages/home/UIListener";

export default class ProfileAPI
{
    public constructor(private api: SocialAPI)
    {
    }

    public async deleteHeadline(headlineID: number): Promise<boolean>
    {
        const response = await this.api.fetch<boolean>(`/headline?headlineID=${headlineID}`, {
            method: "DELETE",
        });

        if (response.status !== HTTPStatus.OK)
        {
            Logger.error("Profile API", `Failed to delete headline: ${response.status} ${response.message}`);

            return false;
        }

        Logger.log("Profile API", "Headline deleted successfully.");

        return true;
    }

    public async deleteSubmission(submissionID: number): Promise<boolean>
    {
        const response = await this.api.fetch<boolean>(`/submission?submissionID=${submissionID}`, {
            method: "DELETE",
        });

        if (response.status !== HTTPStatus.OK)
        {
            Logger.error("Profile API", `Failed to delete submission: ${response.status} ${response.message}`);

            return false;
        }

        Logger.log("Profile API", "Submission deleted successfully.");

        return true;
    }

    public async disconnectTwitch(): Promise<boolean>
    {
        const token = localStorage.getItem("access_token");

        if (!token)
        {
            Logger.error("No access token found for disconnecting from Twitch");

            return false;
        }

        const response = await this.api.fetch<{ access_token: string }>(`/disconnect/twitch?token=${token}`, {
            method: "GET",
        });

        if (response.status !== HTTPStatus.OK)
        {
            Logger.error("Profile API", `Failed to disconnect Twitch: ${response.status} ${response.message}`);

            return false;
        }

        if (!response.data)
        {
            Logger.error("Profile API", "No data returned from Twitch disconnect");

            return false;
        }

        const { access_token } = response.data;

        if (access_token)
        {
            // Updated token
            localStorage.setItem("access_token", access_token);

            UIListener.trigger("validateToken", {});
        }

        Logger.log("Profile API", "Twitch disconnected successfully.");

        return true;
    }
}
